const opcoes = (state = [], action) => {
    switch (action.type) {
      case 'MENU':
      return {
          type: "MENU",
          menu: action.active,
        }
      default:
        return state
    }
  }
  
  export default opcoes